export const blogPosts = [
  {
    id: 1,
    title: "5 tajni savršenog testa za hleb",
    author: "Marko Petrović",
    date: "2026-01-15",
    category: "Hleb",
    image: "/images/blog1.jpg",
    excerpt: "Otkrijte profesionalne tehnike za pripremu testa koje koriste najbolji pekari...",
    content: `
      Priprema savršenog testa za hleb zahteva preciznost i strpljenje. Evo pet ključnih saveta:
      
      1. **Kvalitet brašna** - Koristite brašno sa visokim sadržajem proteina (tip 500 ili 550)
      2. **Temperatura vode** - Idealna temperatura je 24-27°C za aktivaciju kvasca
      3. **Fermentacija** - Pustite testo da se diže najmanje 1-2 sata na sobnoj temperaturi
      4. **Mesenje** - Mešajte testo 10-15 minuta za razvoj glutena
      5. **Para u rerni** - Stavite posudu sa vodom u rernu za hrskavu koricu
      
      Pratite ove korake i vaš hleb će biti uvek savršen!
    `
  },
  {
    id: 2,
    title: "Kako napraviti slojevano testo za kroasane",
    author: "Ana Jovanović",
    date: "2026-01-20",
    category: "Peciva",
    image: "/images/blog2.jpg",
    excerpt: "Detaljan vodič kroz proces pravljenja klasičnog francuskog kroasana...",
    content: `
      Kroasani su umetnička forma u pekarstvu. Proces izrade zahteva vreme ali rezultat je vredan truda.
      
      **Sastojci:**
      - 500g brašna tip 400
      - 250g hladnog putera
      - 10g kvasca
      - 50g šećera
      - 8g soli
      
      **Proces:**
      Testo se savija i razvaljuje više puta da bi se napravili tanki slojevi putera između slojeva testa.
      Idealno je napraviti 27 slojeva kroz tri savijanja (3x3x3).
      
      Ključ uspeha je održavanje hladnoće - radite brzo i vraćajte testo u frižider između savijanja.
    `
  },
  {
    id: 3,
    title: "Zdrave alternative šećeru u kolačima",
    author: "Jelena Nikolić",
    date: "2026-01-25",
    category: "Kolači",
    image: "/images/blog3.jpg",
    excerpt: "Prirodni zaslađivači koji ne kompromituju ukus vaših poslastica...",
    content: `
      Smanjenje šećera u kolačima ne mora značiti žrtvovanje ukusa. Evo najboljih alternativa:
      
      **1. Med** - Prirodan zaslađivač, koristi 3/4 količine umesto šećera
      **2. Javorov sirup** - Bogat mineralima, idealan za kolače
      **3. Agava** - Niži glikemijski indeks od šećera
      **4. Banane** - Savršene za brownie i muffins
      **5. Datulje** - Prirodna sladoća i vlaga
      
      Eksperimentišite i pronađite ono što vam najviše odgovara!
    `
  },
  {
    id: 4,
    title: "Temperatura rerne: Kompletni vodič",
    author: "Stefan Marković",
    date: "2026-01-28",
    category: "Tehnike",
    image: "/images/blog4.jpg",
    excerpt: "Sve što treba da znate o temperaturama pečenja različitih proizvoda...",
    content: `
      Pravilna temperatura je kritična za uspeh pečenja. Evo vodiča:
      
      **Hleb:** 220-240°C (prvi deo), 180-200°C (završetak)
      **Peciva:** 180-200°C
      **Kroasani:** 200-220°C
      **Keks i kolači:** 160-180°C
      **Torte:** 160-170°C
      **Pizza:** 250-280°C
      
      Svaka rerna je drugačija - upoznajte svoju i prilagodite temperature!
    `
  },
  {
    id: 5,
    title: "Dekoracija torte kao profesionalac",
    author: "Milica Simić",
    date: "2026-02-01",
    category: "Dekoracija",
    image: "/images/blog5.jpg",
    excerpt: "Naučite tehnike profesionalne dekoracije koje će impresionirati svakog...",
    content: `
      Dekoracija torte je finalni dodir koji čini tortu nezaboravnom.
      
      **Osnovne tehnike:**
      - Smoothing (zaglađivanje) - Koristite vruću lopaticu
      - Piping - Vežbajte na papiru pre nego na torti
      - Fondant - Razvaljajte ravnomerno na 3-4mm
      - Cvetovi od šećera - Koristite praškasti šećer za oblikovanje
      
      **Pro saveti:**
      - Uvek hladite tortu pre dekoracije
      - Koristite kvalitetne alate
      - Vežbajte strpljivo
      
      Dekoracija zahteva praksu, ali rezultati su zadivljujući!
    `
  }
];
export default blogPosts;